import { render } from "./product.vue?vue&type=template&id=6130298e&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=6130298e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6130298e"],['__file',"resources/js/vueComponents/admin/product.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6130298e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6130298e', __exports__)) {
    api.reload('6130298e', __exports__)
  }
  
  module.hot.accept("./product.vue?vue&type=template&id=6130298e&scoped=true", () => {
    api.rerender('6130298e', render)
  })

}


export default __exports__